/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 08/08/2025.
 */

import { Button } from 'antd'
import React from 'react'

type Props = {
  onClose?: () => void
  eligibilityError: string
}

export const EligiblityCalculationError = ({ onClose, eligibilityError }: Props) => {
  return (
    <div className="col-12 border rounded-2 p-4 ">
      <h5>Subject ineligible for calculation</h5>
      <p>{eligibilityError}</p>

      <Button onClick={onClose} size="large" type="primary" className="w-100 mt-3">
        Close
      </Button>
    </div>
  )
}
